import {useState,  useEffect, useRef} from 'react';
import {BsExclamationCircle} from 'react-icons/bs';
import {updateUTCDate, showToast} from '../../common/app_common.js';
import {PageNation} from '../../common/component_common.js';
import Button from 'react-bootstrap/Button';
import {getApiReceiveEdge, getApiReceiveEdgeCount, getApiReceiveEdgeId, putApiReceiveEdgeIdStatus} from '../../common/fetch_api/coverage.js'
import {DecideWindow} from '../../common/modal_common.js';
import {ReceiveEdgeDetailModal} from './modals.js'

const PAGE_PER = 16;

export const View = ({update, runUpdate}) => {

    const [edgeSelCount, setEdgeSelCount] = useState(1);
    const [curPageState, setCurPageState] = useState(1);
    const curPageRef = useRef(0);

    const [modalEdgeDetail, setModalEdgeDetail] = useState(false);
    const [modalEdgeInfo, setModalEdgeInfo] = useState(null);
    const closeModalEdgeDetail = () => setModalEdgeDetail(false);
    const showModalEdgeDetail = (info) =>
    {
        setModalEdgeInfo(info);
        setModalEdgeDetail(true);
    };

    const [rejectedList, setRejectedList] = useState([]);
    
    const [decideBody, setDecideBody] = useState(null);
    const [decideBtn, setDecideBtn] = useState('OK');
    const [modalDecide, setModalDecide] = useState(false);
    const closeModalDecide = () => setModalDecide(false);
    const showModalDecide = () =>
    {
        let result = checkEdgeId();
        if( result.edgeId.length < 1 )
        {
            showToast("Target not found", "error");
            return;
        }
        
        setDecideBtn('Remove');
        setDecideBody(
            <div className='text-center'>
                <p>Are you sure you want to delete this Edge?</p>
            </div>
        );
        
        setModalDecide(true);
    }

    const onClickAction = (is) => {
        if( is )
        {
            let result = checkEdgeId();
            let apiArr = [];
            
            apiArr = setEdgeStatus('dismiss', result.edgeId);

            Promise.all(apiArr)
            .then( done => {
                runUpdate();
            })
            .catch( err => {});
        }
    }

    function setEdgeStatus(status, edgeArr)
    {
        let apiArr = [];
        for( let edgeId of edgeArr)
        {
            apiArr.push( putApiReceiveEdgeIdStatus(edgeId, status) );
        }

        return apiArr;
    }

    const checkAll = (e) => {
        let tbody = document.getElementById('rejectTbody').childNodes;
        let checked = false;
    
        if( e.target.checked === true )
        {
            checked = true;
        }
    
        tbody.forEach(function(tr) {
            (tr.firstChild.firstChild).checked = checked;
        });
    }
    
    const checkLine = (id) => {
        let input = document.getElementById(id).childNodes[0].firstChild;
        input.checked = !input.checked;
    }
    
    const checkEdgeId = () => {
        let tbody = document.getElementById('rejectTbody').childNodes;
        let edgeId = [];
        let err = false;
    
        tbody.forEach(function(tr) {
            if( (tr.firstChild.firstChild).checked === true )
            {
                edgeId.push( tr.id);
            }
        });
    
        return {'edgeId':edgeId, 'err':err};
    }

    function getUtcTime(sec)
    {
        let checkIn = new Date(0);
        checkIn.setUTCSeconds(sec);
        const result = updateUTCDate(checkIn);

        return result;
    }

    function getOverTime(sec)
    {
        let curTime = new Date();
        let checkIn = new Date(0);
        checkIn.setUTCSeconds(sec);

        if( curTime.getTime() - checkIn.getTime() >= 60000 )
        {
            return "text-warning";
        }

        return '';
    }

    function getReceiveEdges()
    {
        curPageRef.current.value = curPageState;        
            
        Promise.resolve( getApiReceiveEdgeCount('rejected', '') )
        .then( count => {
            
            if(count && count.count > 0)
            {
                setEdgeSelCount(count.count);
                
                let page = Math.ceil(count.count/PAGE_PER);
                if( curPageState > page )
                {
                    setCurPageState(page);
                }
                else
                {
                    page = curPageState;
                }

                Promise.resolve( getApiReceiveEdge(PAGE_PER, page, 'rejected', '', 'name', 'asc') )
                .then( edgeIds => {

                    let api = [];
                    for( const id of edgeIds )
                    {
                        api.push( getApiReceiveEdgeId(id) );
                    }

                    Promise.all( api )
                    .then( data => {
                        setRejectedList( data.map((item, idx) => (
                            <tr key={item.id} id={item.id} onClick={ () => {checkLine(item.id)}}>
                                <td><input className="form-check-input" type="checkbox"onClick={(e) => {e.target.checked = !e.target.checked;}}/></td>
                                <td>{item.id}</td>
                                <td>{item.fingerprint}</td>
                                <td className={getOverTime(item.sec)}>{getUtcTime(item.sec)}</td>
                                <td>{item.clientIp}</td>
                                <td>
                                    <Button variant="primary" className="btn btn-icon" onClick={() => {showModalEdgeDetail(item)}}><BsExclamationCircle/></Button>
                                </td>
                            </tr>
                        )));
                    });
                });
            }
        });
    }

    const ContentsHeader = () => {
        return (
            <thead>
                <tr>
                    <th><input className="form-check-input" type="checkbox" onClick={checkAll}/></th>
                    <th>ID</th>
                    <th>Fingerprint</th>
                    <th>Latest Check in</th>
                    <th>Client IP</th>
                    <th></th>
                </tr>
            </thead>
        );
    };

    useEffect( () => {
        getReceiveEdges();
    }, [update, curPageState]);
    
    return (
        <>
            <div className="d-flex  justify-content-end mt-2 me-2">
                <Button variant="danger" className="btn btn-sm ms-2" onClick={showModalDecide}>Remove</Button>
            </div>
            <div className="section receive-rejected-area mt-2">
                <table className="table table-hover">
                    <ContentsHeader/>
                    <tbody id='rejectTbody'>
                        {rejectedList}
                    </tbody>
                </table>
            </div>
            <PageNation
                curPageState={curPageState}
                setCurPageState={setCurPageState}
                selCount={edgeSelCount}
                pagePer={PAGE_PER}
                ref={curPageRef}
            ></PageNation>
            {modalEdgeDetail&&<ReceiveEdgeDetailModal edgeInfo={modalEdgeInfo} show={modalEdgeDetail} handleClose={closeModalEdgeDetail} update={runUpdate}></ReceiveEdgeDetailModal>}
            {modalDecide&&<DecideWindow result={onClickAction} show={modalDecide} handleClose={closeModalDecide} body={decideBody} okButtonTxt={decideBtn}></DecideWindow>}
        </>
    );
};